export class UnsplashUserLinks {
  html: string;
  photos: string;
}
